/**
 * Ufaks custom JS
 *
 * Burada tema davranışını bozmadan küçük UX iyileştirmeleri yapıyoruz:
 * - Kişiye özel ürünlerde zorunlu alanlar boşsa sepete ekle bloklanır
 * - Hata alanları daha görünür hale getirilir
 */

(function () {
  if (typeof document === 'undefined') return;

  /**
   * Kişiye özel ürünler için basit zorunlu alan validasyonu
   * HTML5 checkValidity zaten çalışıyor; burada sadece UX tarafını güçlendiriyoruz.
   */
  function setupPersonalizedProductValidation() {
    var forms = document.querySelectorAll('form[is="product-form"]');
    if (!forms.length) return;

    // Native invalid event'ini yakalayıp alanı görsel olarak vurgula
    document.addEventListener(
      'invalid',
      function (event) {
        var target = event.target;
        if (!(target instanceof HTMLElement)) return;
        if (!target.closest('form[is="product-form"]')) return;

        // Line item property alanı ise, kenarlığı vurgula
        if (
          target.matches(
            '.product-form__line-item-property .input__field, .product-form__line-item-property textarea, .product-form__line-item-property input'
          )
        ) {
          target.style.borderColor = '#f04438';
          target.style.boxShadow = '0 0 0 1px rgba(240, 68, 56, 0.4)';
        }
      },
      true
    );

    // Submit öncesi manuel kontrol: boş required alan varsa yukarı kaydır
    forms.forEach(function (form) {
      form.addEventListener(
        'submit',
        function (event) {
          var requiredFields = form.querySelectorAll('.product-form__line-item-property [required]');
          if (!requiredFields.length) return;

          var firstInvalid = null;
          requiredFields.forEach(function (field) {
            if (!field.value || (field.type === 'checkbox' && !field.checked)) {
              if (!firstInvalid) firstInvalid = field;
            }
          });

          if (firstInvalid) {
            event.preventDefault();
            // Native hata mesajını da göster
            if (typeof firstInvalid.reportValidity === 'function') {
              firstInvalid.reportValidity();
            }

            firstInvalid.focus({ preventScroll: true });
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        },
        true
      );
    });
  }

  function debounce(fn, delay) {
    var timer = null;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(null, args);
      }, delay);
    };
  }

  function supportPredictiveApi() {
    try {
      var featuresEl = document.getElementById('shopify-features');
      if (!featuresEl) return false;
      var shopifyFeatureRequests = JSON.parse(featuresEl.innerHTML);
      return !!shopifyFeatureRequests['predictiveSearch'];
    } catch (e) {
      return false;
    }
  }

  function setupInlineHeaderSearch() {
    var trigger = document.querySelector('[data-inline-search-open]');
    var root = document.getElementById('inline-header-search');
    if (!trigger || !root) return;

    var overlay = root.querySelector('[data-inline-search-close]');
    var input = root.querySelector('[data-inline-search-input]');
    var defaultEl = root.querySelector('[data-inline-search-default]');
    var loadingEl = root.querySelector('[data-inline-search-loading]');
    var resultsEl = root.querySelector('[data-inline-search-results]');
    var abortController = null;

    if (!input || !defaultEl || !loadingEl || !resultsEl) return;

    function openPanel() {
      root.classList.add('inline-header-search--open');
      root.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('header-search-panel-open');
      setTimeout(function () {
        input.focus();
      }, 60);
    }

    function closePanel() {
      root.classList.remove('inline-header-search--open');
      root.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('header-search-panel-open');
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (root.classList.contains('inline-header-search--open')) {
        closePanel();
      } else {
        openPanel();
      }
    });

    overlay.addEventListener('click', function () {
      closePanel();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('inline-header-search--open')) {
        closePanel();
      }
    });

    async function doPredictiveSearch(term) {
      if (!window.themeVariables || !window.themeVariables.routes) return { hasResults: false, html: '' };

      var url;
      if (supportPredictiveApi()) {
        url =
          window.themeVariables.routes.predictiveSearchUrl +
          '?q=' +
          encodeURIComponent(term) +
          '&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search';
      } else {
        url =
          window.themeVariables.routes.searchUrl +
          '?q=' +
          encodeURIComponent(term) +
          '&resources[limit]=50&section_id=predictive-search-compatibility';
      }

      abortController = new AbortController();

      var response = await fetch(url, { signal: abortController.signal });
      var div = document.createElement('div');
      div.innerHTML = await response.text();
      var first = div.firstElementChild;

      return {
        hasResults: !!(first && first.querySelector('.predictive-search__results-categories')),
        html: first ? first.innerHTML : '',
      };
    }

    var handleInput = debounce(async function () {
      var value = input.value.trim();

      if (abortController) {
        abortController.abort();
        abortController = null;
      }

      if (!value) {
        loadingEl.hidden = true;
        resultsEl.hidden = true;
        defaultEl.hidden = false;
        resultsEl.innerHTML = '';
        return;
      }

      defaultEl.hidden = true;
      loadingEl.hidden = false;
      resultsEl.hidden = true;

      var searchResults = {};
      try {
        searchResults = await doPredictiveSearch(value);
      } catch (e) {
        if (e.name === 'AbortError') return;
      }

      loadingEl.hidden = true;
      resultsEl.hidden = false;
      resultsEl.innerHTML = searchResults.html || '';
    }, 200);

    input.addEventListener('input', handleInput);
  }

  function setupStickyCountdownBar() {
    var selector = '[data-ufaks-sticky-countdown]';
    var isProductPage =
      window.themeVariables &&
      window.themeVariables.settings &&
      window.themeVariables.settings.pageType === 'product';

    if (!isProductPage) return;

    function bindCountdown(el) {
      if (!el || el.dataset.ufaksStickyCountdownBound === 'true') return;

      var targetAttr = el.getAttribute('data-ufaks-sticky-countdown');
      if (!targetAttr) return;

      var targetTime = Date.parse(targetAttr);
      if (!isFinite(targetTime)) return;

      var percentAttr = el.getAttribute('data-ufaks-sticky-percent');
      var percent = percentAttr ? parseInt(percentAttr, 10) : 0;

      el.dataset.ufaksStickyCountdownBound = 'true';

      function update() {
        var now = Date.now();
        var distance = targetTime - now;

        if (distance <= 0) {
          el.textContent = 'İndirim sona erdi';
          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor(
          (distance % (1000 * 60 * 60)) / (1000 * 60)
        );
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // 3 günden fazla varsa sadece sınırlı süre mesajı göster
        if (days > 3) {
          if (percent > 0) {
            el.textContent = '%' + percent + ' İNDİRİM - Sınırlı süre geçerli';
          } else {
            el.textContent = 'Sınırlı süre geçerli.';
          }
          return;
        }

        var text = '';
        if (percent > 0) {
          text += '%' + percent + ' İndirim! - ';
        }
        if (days >= 1) {
          // 1–3 gün arası: gün, saat, dakika, saniye
          text +=
            days +
            ' Gün ' +
            hours +
            ' Saat ' +
            minutes +
            ' Dakika ' +
            seconds +
            ' Saniye';
        } else {
          // 1 günden az: sadece saat, dakika, saniye
          text +=
            hours +
            ' Saat ' +
            minutes +
            ' Dakika ' +
            seconds +
            ' Saniye';
        }

        el.textContent = text;
      }

      update();

      var intervalId = window.setInterval(function () {
        update();
        if (Date.now() >= targetTime) {
          window.clearInterval(intervalId);
        }
      }, 1000);
    }

    function scan(root) {
      var scope = root || document;
      var els = scope.querySelectorAll(selector);
      if (!els.length) return;
      els.forEach(bindCountdown);
    }

    scan(document);

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target) return;
      scan(event.target);
    });

    /**
     * Varyant değişimlerinde tema, `product-rerender` içeriğini
     * yeniden çiziyor. Bu sırada sayaç elementi DOM'dan silinip
     * tekrar eklendiği için, ilk yüklemede bağladığımız sayaç
     * yeniden çalışmıyor olabilir.
     *
     * Bunu çözmek için, hafif bir MutationObserver ile sayacın
     * yeniden eklendiği alanları tarayıp countdown'u tekrar bağlıyoruz.
     */
    try {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (!mutation.addedNodes || !mutation.addedNodes.length) return;

          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof HTMLElement)) return;

            // Eklenen düğümün kendisi sayaç ise
            if (node.matches && node.matches(selector)) {
              bindCountdown(node);
              return;
            }

            // İçinde sayaç barındıran bir alt ağaç ise
            scan(node);
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    } catch (e) {
      // Eski tarayıcılar için sessizce yoksay
    }
  }

  function setupModelYearWarningPopup() {
    var POPUP_ID = 'ufaks-model-year-warning-popup';
    var STYLE_ID = 'ufaks-model-year-warning-popup-styles';
    var STORAGE_KEY = 'ufaks_model_year_warning_last_shown_at';
    var COOLDOWN_MS = 30 * 1000;
    var popup = null;
    var hideTimer = null;
    var lastFocusedElement = null;
    var shouldRestoreMiniCart = false;

    function getStorage() {
      try {
        return window.localStorage;
      } catch (e) {
        return null;
      }
    }

    function getLastShownAt() {
      var storage = getStorage();
      if (!storage) return 0;

      var value = parseInt(storage.getItem(STORAGE_KEY) || '0', 10);
      return isNaN(value) ? 0 : value;
    }

    function setLastShownAt() {
      var storage = getStorage();
      if (!storage) return;

      storage.setItem(STORAGE_KEY, String(Date.now()));
    }

    function isInCooldown() {
      return Date.now() - getLastShownAt() < COOLDOWN_MS;
    }

    function ensureStyles() {
      if (document.getElementById(STYLE_ID)) return;

      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent =
        '#' +
        POPUP_ID +
        ' {' +
        ' position: fixed;' +
        ' inset: 0;' +
        ' z-index: 15;' +
        ' display: flex;' +
        ' align-items: flex-end;' +
        ' justify-content: center;' +
        ' padding: 16px;' +
        ' opacity: 0;' +
        ' pointer-events: none;' +
        ' transition: opacity 0.2s ease;' +
        '}' +
        '#' +
        POPUP_ID +
        '.is-active {' +
        ' opacity: 1;' +
        ' pointer-events: auto;' +
        '}' +
        '#' +
        POPUP_ID +
        ' .ufaks-model-warning-popup__backdrop {' +
        ' position: absolute;' +
        ' inset: 0;' +
        ' background: rgba(0, 0, 0, 0.52);' +
        '}' +
        '#' +
        POPUP_ID +
        ' .ufaks-model-warning-popup__dialog {' +
        ' position: relative;' +
        ' width: min(100%, 560px);' +
        ' background: rgb(var(--background));' +
        ' color: rgb(var(--text-color));' +
        ' border-radius: 18px;' +
        ' box-shadow: 0 20px 60px rgba(0, 0, 0, 0.24);' +
        ' transform: translateY(16px) scale(0.98);' +
        ' opacity: 0;' +
        ' transition: transform 0.2s ease, opacity 0.2s ease;' +
        ' overflow: hidden;' +
        '}' +
        '#' +
        POPUP_ID +
        '.is-active .ufaks-model-warning-popup__dialog {' +
        ' transform: translateY(0) scale(1);' +
        ' opacity: 1;' +
        '}' +
        '#' +
        POPUP_ID +
        ' .ufaks-model-warning-popup__content {' +
        ' padding: 28px 24px 24px;' +
        '}' +
        '#' +
        POPUP_ID +
        ' .ufaks-model-warning-popup__eyebrow {' +
        ' display: inline-flex;' +
        ' align-items: center;' +
        ' gap: 8px;' +
        ' margin-bottom: 14px;' +
        ' padding: 6px 12px;' +
        ' border-radius: 999px;' +
        ' background: rgba(var(--text-color), 0.07);' +
        ' font-size: 0.82rem;' +
        ' font-weight: 600;' +
        '}' +
        '#' +
        POPUP_ID +
        ' .ufaks-model-warning-popup__eyebrow::before {' +
        ' content: "!";' +
        ' display: inline-flex;' +
        ' align-items: center;' +
        ' justify-content: center;' +
        ' width: 20px;' +
        ' height: 20px;' +
        ' border-radius: 999px;' +
        ' background: #f04438;' +
        ' color: #fff;' +
        ' font-size: 0.78rem;' +
        ' font-weight: 700;' +
        '}' +
        '#' +
        POPUP_ID +
        ' .ufaks-model-warning-popup__title {' +
        ' margin: 0 32px 12px 0;' +
        '}' +
        '#' +
        POPUP_ID +
        ' .ufaks-model-warning-popup__text {' +
        ' margin: 0 0 20px;' +
        ' color: rgba(var(--text-color), 0.78);' +
        ' line-height: 1.65;' +
        '}' +
        '#' +
        POPUP_ID +
        ' .ufaks-model-warning-popup__actions {' +
        ' display: flex;' +
        ' justify-content: flex-start;' +
        '}' +
        '#' +
        POPUP_ID +
        ' .ufaks-model-warning-popup__close {' +
        ' position: absolute;' +
        ' top: 14px;' +
        ' right: 14px;' +
        ' padding: 8px 10px;' +
        ' color: rgba(var(--text-color), 0.72);' +
        ' font-size: 0.92rem;' +
        ' line-height: 1;' +
        '}' +
        '@media screen and (min-width: 741px) {' +
        ' #' +
        POPUP_ID +
        ' {' +
        ' align-items: center;' +
        ' padding: 24px;' +
        ' }' +
        ' #' +
        POPUP_ID +
        ' .ufaks-model-warning-popup__content {' +
        ' padding: 32px;' +
        ' }' +
        '}' +
        '@media screen and (max-width: 740px) {' +
        ' #' +
        POPUP_ID +
        ' .ufaks-model-warning-popup__dialog {' +
        ' width: 100%;' +
        ' border-radius: 18px 18px 0 0;' +
        ' }' +
        '}';

      document.head.appendChild(style);
    }

    function ensurePopup() {
      if (popup) return popup;

      ensureStyles();

      popup = document.getElementById(POPUP_ID);

      if (popup) return popup;

      popup = document.createElement('div');
      popup.id = POPUP_ID;
      popup.hidden = true;
      popup.innerHTML =
        '<div class="ufaks-model-warning-popup__backdrop" data-model-warning-close></div>' +
        '<div class="ufaks-model-warning-popup__dialog" role="dialog" aria-modal="true" aria-labelledby="ufaks-model-warning-popup-title" aria-describedby="ufaks-model-warning-popup-description">' +
        '  <button type="button" class="ufaks-model-warning-popup__close link" data-model-warning-close aria-label="Kapat">Kapat</button>' +
        '  <div class="ufaks-model-warning-popup__content text-container">' +
        '    <div class="ufaks-model-warning-popup__eyebrow">Model uyumluluk uyarısı</div>' +
        '    <h2 id="ufaks-model-warning-popup-title" class="ufaks-model-warning-popup__title heading h5">Bu ürün 2025 ve 2026 modelleri ile uyumludur.</h2>' +
        '    <p id="ufaks-model-warning-popup-description" class="ufaks-model-warning-popup__text">Sepetinize eklediğiniz ürün <b>2025 ve 2026 model Honda PCX ile uyumlu bir üründür.</b> Eğer motosikletiniz 2025 veya 2026 model değilse lütfen uyumlu ürünü tercih ediniz. Model yılları ürün başlıklarında yer almaktadır.</p>' +
        '    <div class="ufaks-model-warning-popup__actions">' +
        '      <button type="button" class="button button--primary" data-model-warning-primary data-model-warning-close>Anladım</button>' +
        '    </div>' +
        '  </div>' +
        '</div>';

      popup.addEventListener('click', function (event) {
        event.stopPropagation();

        var target = event.target;
        if (!(target instanceof HTMLElement)) return;

        if (target.closest('[data-model-warning-close]')) {
          event.preventDefault();
          closePopup();
        }
      });

      document.body.appendChild(popup);

      return popup;
    }

    function shouldKeepMiniCartOpen(form) {
      return !!(
        form &&
        window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.cartType === 'drawer' &&
        form.closest('.drawer') === null
      );
    }

    function restoreMiniCart() {
      if (!shouldRestoreMiniCart) return;

      var miniCart = document.getElementById('mini-cart');
      if (!miniCart || miniCart.open) return;

      requestAnimationFrame(function () {
        miniCart.open = true;
      });
    }

    function openPopup(form) {
      var popupEl = ensurePopup();
      if (!popupEl) return;

      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }

      shouldRestoreMiniCart = shouldKeepMiniCartOpen(form);
      lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      setLastShownAt();
      popupEl.hidden = false;

      requestAnimationFrame(function () {
        popupEl.classList.add('is-active');
      });

      var primaryButton = popupEl.querySelector('[data-model-warning-primary]');
      if (primaryButton instanceof HTMLElement) {
        setTimeout(function () {
          primaryButton.focus();
        }, 40);
      }
    }

    function closePopup() {
      var popupEl = ensurePopup();
      if (!popupEl || popupEl.hidden) return;

      popupEl.classList.remove('is-active');

      hideTimer = setTimeout(function () {
        popupEl.hidden = true;
        hideTimer = null;

        if (lastFocusedElement && document.contains(lastFocusedElement)) {
          lastFocusedElement.focus();
        }

        restoreMiniCart();
      }, 220);
    }

    document.addEventListener('variant:added', function (event) {
      var form = event.target;

      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('data-model-year-warning-enabled') !== 'true') return;
      if (isInCooldown()) return;

      openPopup(form);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!popup || popup.hidden) return;

      closePopup();
    });
  }

  /**
   * Sim Hizmeti + Kişiselleştirme Hizmeti: isteğe bağlı ek satırlar, sepette ana ürünle senkron.
   */
  function setupSimHizmetiUpsell() {
    var upsellSubmitBoundKey = 'ufaksUpsellSubmitBound';

    /**
     * Mobilde (≤999px) pocket, masaüstünde desk kökü — offsetParent görünürlük testi custom element / iOS’ta yanılabiliyordu.
     */
    function findSimUpsellRoot(form) {
      if (!(form instanceof HTMLFormElement)) return null;
      var col = form.closest('.product__info');
      if (!col) return null;
      var roots = col.querySelectorAll('[data-ufaks-sim-hizmeti]');
      if (!roots.length) return null;
      var wantPocket = false;
      try {
        wantPocket = window.matchMedia('(max-width: 999px)').matches;
      } catch (e) {
        wantPocket = window.innerWidth <= 999;
      }
      var want = wantPocket ? 'pocket' : 'desk';
      var i;
      for (i = 0; i < roots.length; i++) {
        if (roots[i].getAttribute('data-ufaks-sim-slot') === want) return roots[i];
      }
      return roots[0];
    }

    function findPersUpsellRoot(form) {
      if (!(form instanceof HTMLFormElement)) return null;
      var col = form.closest('.product__info');
      if (!col) return null;
      var roots = col.querySelectorAll('[data-ufaks-kisisellestirme]');
      if (!roots.length) return null;
      var wantPocket = false;
      try {
        wantPocket = window.matchMedia('(max-width: 999px)').matches;
      } catch (e) {
        wantPocket = window.innerWidth <= 999;
      }
      var want = wantPocket ? 'pocket' : 'desk';
      var i;
      for (i = 0; i < roots.length; i++) {
        if (roots[i].getAttribute('data-ufaks-pers-slot') === want) return roots[i];
      }
      return roots[0];
    }

    function setPersPanelOpen(root, open) {
      if (!root) return;
      var panel = root.querySelector('[data-ufaks-pers-panel]');
      var cb = root.querySelector('[data-ufaks-pers-checkbox]');
      if (panel) panel.hidden = !open;
      if (cb) cb.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function getPersNameFromRoot(root) {
      if (!root) return '';
      var input = root.querySelector('[data-ufaks-pers-name]');
      return input ? String(input.value || '').trim() : '';
    }

    function normalizeItemProperties(item) {
      var raw = item && item.properties;
      if (!raw) return {};
      if (Array.isArray(raw)) {
        var o = {};
        raw.forEach(function (entry) {
          if (!entry) return;
          var k = entry.name != null ? entry.name : entry.first;
          var v = entry.value != null ? entry.value : entry.last;
          if (k != null) o[String(k)] = v == null ? '' : String(v);
        });
        return o;
      }
      if (typeof raw === 'object') return raw;
      return {};
    }

    function getLinkedParentVariantId(props) {
      if (!props) return '';
      var v = props['_ufaks_ana_urun_varyant'];
      if (v == null || v === '') v = props['_Ana_varyant'];
      if (v == null || v === '') v = props.ufaks_ana_urun_varyant;
      return String(v == null ? '' : v).trim();
    }

    function getLinkedParentVariantIdFromItem(item) {
      return getLinkedParentVariantId(normalizeItemProperties(item));
    }

    function inferSimProductIdFromCart(cart) {
      if (!cart || !cart.items) return null;
      var found = null;
      var handle = window.ufaksSimHizmeti && window.ufaksSimHizmeti.productHandle;
      cart.items.forEach(function (item) {
        if (getLinkedParentVariantIdFromItem(item) !== '') {
          found = item.product_id;
        }
      });
      if (!found) {
        cart.items.forEach(function (item) {
          var p = normalizeItemProperties(item);
          if (p['_ufaks_ana_urun_varyant'] || p['_Ana_varyant']) {
            found = item.product_id;
          }
        });
      }
      if (!found && handle) {
        cart.items.forEach(function (item) {
          if (item.handle === handle) {
            found = item.product_id;
          }
        });
      }
      return found;
    }

    function getSimServiceProductId(cart) {
      var raw =
        window.ufaksSimHizmeti && window.ufaksSimHizmeti.productId != null
          ? window.ufaksSimHizmeti.productId
          : inferSimProductIdFromCart(cart);
      if (raw == null || raw === '') return null;
      return String(raw);
    }

    function inferPersProductIdFromCart(cart) {
      if (!cart || !cart.items) return null;
      var found = null;
      var handle = window.ufaksKisisellestirme && window.ufaksKisisellestirme.productHandle;
      var persPid =
        window.ufaksKisisellestirme && window.ufaksKisisellestirme.productId != null
          ? String(window.ufaksKisisellestirme.productId)
          : '';
      cart.items.forEach(function (item) {
        if (persPid && String(item.product_id) === persPid && getLinkedParentVariantIdFromItem(item) !== '') {
          found = item.product_id;
        }
      });
      if (!found) {
        cart.items.forEach(function (item) {
          var p = normalizeItemProperties(item);
          if (
            (p['_ufaks_ana_urun_varyant'] || p['_Ana_varyant']) &&
            (p['Yazılacak isim'] || p['Yazilacak isim'])
          ) {
            found = item.product_id;
          }
        });
      }
      if (!found && handle) {
        cart.items.forEach(function (item) {
          if (item.handle === handle) {
            found = item.product_id;
          }
        });
      }
      return found;
    }

    function getPersServiceProductId(cart) {
      var raw =
        window.ufaksKisisellestirme && window.ufaksKisisellestirme.productId != null
          ? window.ufaksKisisellestirme.productId
          : inferPersProductIdFromCart(cart);
      if (raw == null || raw === '') return null;
      return String(raw);
    }

    function collectMainLineItemFromForm(form) {
      var fd = new FormData(form);
      var id = parseInt(String(fd.get('id') || ''), 10);
      var qty = parseInt(String(fd.get('quantity') || '1'), 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      var properties = {};
      fd.forEach(function (value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && value !== '' && value != null) properties[m[1]] = String(value);
      });
      var item = { id: id, quantity: qty, properties: properties };
      var sp = fd.get('selling_plan');
      if (sp) {
        var spn = parseInt(String(sp), 10);
        if (!isNaN(spn)) item.selling_plan = spn;
      }
      return item;
    }

    function setFormSubmitBusy(form, busy) {
      var submitButtons = Array.from(form.elements).filter(function (b) {
        return b.type === 'submit';
      });
      submitButtons.forEach(function (btn) {
        if (busy) {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('aria-busy', 'true');
        } else {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-busy');
        }
      });
    }

    function handleCartAddResponse(form, response, responseJson, variantAddedOverride) {
      setFormSubmitBusy(form, false);
      if (response.ok) {
        if (
          window.themeVariables.settings.cartType === 'page' ||
          window.themeVariables.settings.pageType === 'cart'
        ) {
          window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/') + 'cart';
          return;
        }
        var variantPayload =
          variantAddedOverride != null
            ? variantAddedOverride
            : responseJson.hasOwnProperty('items')
              ? responseJson.items[0]
              : responseJson;
        form.dispatchEvent(
          new CustomEvent('variant:added', {
            bubbles: true,
            detail: { variant: variantPayload },
          })
        );
        fetch(window.themeVariables.routes.cartUrl + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cartContent) {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:updated', {
                bubbles: true,
                detail: { cart: cartContent },
              })
            );
            cartContent.sections = responseJson.sections;
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  cart: cartContent,
                  openMiniCart:
                    window.themeVariables.settings.cartType === 'drawer' && form.closest('.drawer') === null,
                },
              })
            );
          });
      }
      form.dispatchEvent(
        new CustomEvent('cart-notification:show', {
          bubbles: true,
          cancelable: true,
          detail: {
            status: response.ok ? 'success' : 'error',
            error: responseJson.description || responseJson.message || '',
          },
        })
      );
    }

    function refreshCartUiFromServer(form, sectionsJson) {
      fetch(window.themeVariables.routes.cartUrl + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cartContent) {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: cartContent },
            })
          );
          if (sectionsJson) cartContent.sections = sectionsJson;
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart:
                  window.themeVariables.settings.cartType === 'drawer' && form.closest('.drawer') === null,
              },
            })
          );
        })
        .catch(function () {});
    }

    function buildLinkedAddonLineUpdates(cart, addonPid) {
      var addonPidStr = String(addonPid);
      var mainQtyByVariant = {};
      cart.items.forEach(function (item) {
        if (String(item.product_id) === addonPidStr) return;
        var vid = String(item.variant_id);
        mainQtyByVariant[vid] = (mainQtyByVariant[vid] || 0) + item.quantity;
      });

      var updates = {};
      cart.items.forEach(function (item) {
        if (String(item.product_id) !== addonPidStr) return;
        var parent = getLinkedParentVariantIdFromItem(item);
        if (parent === '') {
          if (item.key) updates[item.key] = 0;
        }
      });

      var byParent = {};
      cart.items.forEach(function (item) {
        if (String(item.product_id) !== addonPidStr) return;
        var parent = getLinkedParentVariantIdFromItem(item);
        if (parent === '') return;
        if (!item.key) return;
        if (!byParent[parent]) byParent[parent] = [];
        byParent[parent].push({ key: item.key, quantity: item.quantity });
      });

      Object.keys(byParent).forEach(function (parent) {
        var pq = mainQtyByVariant[parent] || 0;
        var lines = byParent[parent];
        var totalAddon = lines.reduce(function (s, L) {
          return s + L.quantity;
        }, 0);
        if (pq === 0) {
          lines.forEach(function (L) {
            updates[L.key] = 0;
          });
        } else if (totalAddon !== pq) {
          lines.forEach(function (L, i) {
            updates[L.key] = i === 0 ? pq : 0;
          });
        }
      });
      return updates;
    }

    function postSingleCartAdd(item, sections) {
      return fetch(window.themeVariables.routes.cartAddUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items: [item], sections: sections }),
      }).then(function (response) {
        return response.json().then(function (json) {
          return { response: response, json: json };
        });
      });
    }

    function onUfaksUpsellFormSubmit(event) {
      var form = event.currentTarget;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('is') !== 'product-form') return;

      var simRoot = findSimUpsellRoot(form);
      var persRoot = findPersUpsellRoot(form);
      var simCb = simRoot ? simRoot.querySelector('[data-ufaks-sim-checkbox]') : null;
      var persCb = persRoot ? persRoot.querySelector('[data-ufaks-pers-checkbox]') : null;
      var wantsSim = !!(simCb && simCb.checked);
      var wantsPers = !!(persCb && persCb.checked);
      if (!wantsSim && !wantsPers) return;

      var persName = wantsPers ? getPersNameFromRoot(persRoot) : '';
      if (wantsPers && !persName) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var infoCol = form.closest('.product__info');
        if (infoCol) {
          infoCol.querySelectorAll('[data-ufaks-pers-checkbox]').forEach(function (cb) {
            if (cb.checked) setPersPanelOpen(cb.closest('[data-ufaks-kisisellestirme]'), true);
          });
        }
        setPersPanelOpen(persRoot, true);
        var nameInput = persRoot && persRoot.querySelector('[data-ufaks-pers-name]');
        if (nameInput) {
          nameInput.classList.add('ufaks-pers-upsell__input--error');
          nameInput.setCustomValidity('Lütfen yazılacak ismi girin.');
          nameInput.reportValidity();
          nameInput.focus();
        }
        return;
      }

      if (!form.checkValidity()) return;

      var mainItem = collectMainLineItemFromForm(form);
      if (isNaN(mainItem.id)) return;

      var simVariantId = NaN;
      var persVariantId = NaN;
      if (wantsSim && simRoot) {
        simVariantId = parseInt(String(simRoot.getAttribute('data-sim-variant-id') || ''), 10);
        if (isNaN(simVariantId)) return;
      }
      if (wantsPers && persRoot) {
        persVariantId = parseInt(String(persRoot.getAttribute('data-pers-variant-id') || ''), 10);
        if (isNaN(persVariantId)) return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      mainItem.properties = mainItem.properties || {};
      if (wantsSim) mainItem.properties.Simli = 'Evet';
      if (wantsPers) mainItem.properties['Kişiselleştirme'] = persName;

      var parentTitle = '';
      if (simRoot) parentTitle = (simRoot.getAttribute('data-ufaks-parent-product-title') || '').trim();
      if (!parentTitle && persRoot) {
        parentTitle = (persRoot.getAttribute('data-ufaks-parent-product-title') || '').trim();
      }

      var addonQueue = [];
      if (wantsSim) {
        var simItem = {
          id: simVariantId,
          quantity: mainItem.quantity,
          properties: {
            _ufaks_ana_urun_varyant: String(mainItem.id),
            _Ana_varyant: String(mainItem.id),
          },
        };
        if (parentTitle) simItem.properties['İlgili ürün'] = parentTitle;
        addonQueue.push(simItem);
      }
      if (wantsPers) {
        var persItem = {
          id: persVariantId,
          quantity: mainItem.quantity,
          properties: {
            _ufaks_ana_urun_varyant: String(mainItem.id),
            _Ana_varyant: String(mainItem.id),
            'Yazılacak isim': persName,
          },
        };
        if (parentTitle) persItem.properties['İlgili ürün'] = parentTitle;
        addonQueue.push(persItem);
      }

      setFormSubmitBusy(form, true);
      var miniCartSections = ['mini-cart'];

      postSingleCartAdd(mainItem, miniCartSections)
        .then(function (packMain) {
          if (!packMain.response.ok) {
            handleCartAddResponse(form, packMain.response, packMain.json);
            return null;
          }
          return addonQueue.reduce(function (chain, addonItem) {
            return chain.then(function (state) {
              return postSingleCartAdd(addonItem, miniCartSections).then(function (addonPack) {
                return { main: state.main, last: addonPack };
              });
            });
          }, Promise.resolve({ main: packMain, last: packMain }));
        })
        .then(function (state) {
          if (!state) return;
          if (!state.last.response.ok) {
            setFormSubmitBusy(form, false);
            refreshCartUiFromServer(form, state.last.json && state.last.json.sections);
            form.dispatchEvent(
              new CustomEvent('cart-notification:show', {
                bubbles: true,
                cancelable: true,
                detail: {
                  status: 'error',
                  error: state.last.json.description || state.last.json.message || '',
                },
              })
            );
            return;
          }
          var mainLine =
            state.main.json && state.main.json.items && state.main.json.items[0]
              ? state.main.json.items[0]
              : state.main.json;
          handleCartAddResponse(form, state.last.response, state.last.json, mainLine);
        })
        .catch(function () {
          setFormSubmitBusy(form, false);
          form.dispatchEvent(
            new CustomEvent('cart-notification:show', {
              bubbles: true,
              cancelable: true,
              detail: { status: 'error', error: '' },
            })
          );
        });
    }

    function bindUfaksUpsellFormsIn(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('form[is="product-form"]').forEach(function (form) {
        if (!findSimUpsellRoot(form) && !findPersUpsellRoot(form)) return;
        if (form.dataset[upsellSubmitBoundKey] === 'true') return;
        form.dataset[upsellSubmitBoundKey] = 'true';
        form.addEventListener('submit', onUfaksUpsellFormSubmit, true);
      });
    }

    bindUfaksUpsellFormsIn(document);

    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || !t.matches) return;
        if (t.matches('[data-ufaks-sim-checkbox]')) {
          var info = t.closest('.product__info');
          if (!info) return;
          info.querySelectorAll('[data-ufaks-sim-checkbox]').forEach(function (cb) {
            if (cb !== t) cb.checked = t.checked;
          });
          return;
        }
        if (t.matches('[data-ufaks-pers-checkbox]')) {
          var infoPers = t.closest('.product__info');
          if (!infoPers) return;
          infoPers.querySelectorAll('[data-ufaks-pers-checkbox]').forEach(function (cb) {
            if (cb !== t) cb.checked = t.checked;
            setPersPanelOpen(cb.closest('[data-ufaks-kisisellestirme]'), cb.checked);
          });
          setPersPanelOpen(t.closest('[data-ufaks-kisisellestirme]'), t.checked);
          if (!t.checked) {
            var inp = t.closest('[data-ufaks-kisisellestirme]');
            inp = inp && inp.querySelector('[data-ufaks-pers-name]');
            if (inp) {
              inp.classList.remove('ufaks-pers-upsell__input--error');
              inp.setCustomValidity('');
            }
          }
        }
      },
      true
    );

    document.addEventListener('product:rerender', function () {
      bindUfaksUpsellFormsIn(document);
    });

    var syncLock = false;
    var addonSyncTimer = null;

    function ufaksSyncAddonCartLines(prefetchedCart) {
      if (syncLock) return Promise.resolve();
      syncLock = true;
      var cartJs =
        window.themeVariables.routes.cartUrl + '.js?t=' + String(Date.now());
      var cartPromise =
        prefetchedCart && Array.isArray(prefetchedCart.items)
          ? Promise.resolve(prefetchedCart)
          : fetch(cartJs, { credentials: 'same-origin', cache: 'no-store' }).then(function (r) {
              return r.json();
            });
      return cartPromise
        .then(function (cart) {
          var updates = {};
          var simPid = getSimServiceProductId(cart);
          if (simPid) {
            Object.assign(updates, buildLinkedAddonLineUpdates(cart, simPid));
          }
          var persPid = getPersServiceProductId(cart);
          if (persPid) {
            Object.assign(updates, buildLinkedAddonLineUpdates(cart, persPid));
          }
          if (!Object.keys(updates).length) return Promise.resolve(null);
          return fetch(window.themeVariables.routes.cartUrl + '/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates }),
          }).then(function (res) {
            if (!res.ok) {
              return Promise.resolve(null);
            }
            return res.json();
          });
        })
        .then(function (cartContent) {
          if (!cartContent || !cartContent.items) return;
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: cartContent },
            })
          );
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart: cartContent, replacementDelay: 420 },
            })
          );
        })
        .catch(function () {})
        .finally(function () {
          syncLock = false;
        });
    }

    function scheduleUfaksAddonCartSync(delayMs) {
      var delay = typeof delayMs === 'number' ? delayMs : 40;
      if (addonSyncTimer) clearTimeout(addonSyncTimer);
      addonSyncTimer = setTimeout(function () {
        addonSyncTimer = null;
        ufaksSyncAddonCartLines();
      }, delay);
    }

    function handleCartMaybeSyncAddons(ev) {
      var c = ev && ev.detail && ev.detail.cart;
      if (c && Array.isArray(c.items)) {
        if (addonSyncTimer) {
          clearTimeout(addonSyncTimer);
          addonSyncTimer = null;
        }
        ufaksSyncAddonCartLines(c);
        return;
      }
      scheduleUfaksAddonCartSync(40);
    }

    document.documentElement.addEventListener('cart:updated', handleCartMaybeSyncAddons, false);
    document.documentElement.addEventListener('line-item-quantity:change:end', handleCartMaybeSyncAddons, false);

    function runCartPageAddonSync() {
      if (!window.themeVariables || window.themeVariables.settings.pageType !== 'cart') return;
      scheduleUfaksAddonCartSync();
    }

    if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runCartPageAddonSync);
      } else {
        runCartPageAddonSync();
      }
      window.addEventListener('load', runCartPageAddonSync);
      window.addEventListener('pageshow', function (ev) {
        if (ev.persisted) runCartPageAddonSync();
      });
    }

    function ufaksOpenUpsellModal(dlg) {
      if (!dlg) return;
      dlg.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function ufaksCloseUpsellModal(modal) {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    document.addEventListener('click', function (event) {
      var t = event.target;
      if (!(t instanceof Element)) return;
      var openBtn = t.closest('[data-ufaks-sim-open-dialog], [data-ufaks-pers-open-dialog]');
      if (openBtn) {
        var id = openBtn.getAttribute('aria-controls');
        var dlg = id ? document.getElementById(id) : null;
        if (dlg && (dlg.hasAttribute('data-ufaks-sim-modal') || dlg.hasAttribute('data-ufaks-pers-modal'))) {
          event.preventDefault();
          ufaksOpenUpsellModal(dlg);
        }
        return;
      }
      var closeBtn = t.closest('[data-ufaks-sim-close-dialog], [data-ufaks-pers-close-dialog]');
      if (closeBtn) {
        var modal = closeBtn.closest('[data-ufaks-sim-modal], [data-ufaks-pers-modal]');
        if (modal) {
          event.preventDefault();
          ufaksCloseUpsellModal(modal);
          return;
        }
        var dlg2 = closeBtn.closest('dialog');
        if (dlg2 && typeof dlg2.close === 'function') dlg2.close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var modals = document.querySelectorAll('[data-ufaks-sim-modal], [data-ufaks-pers-modal]');
      var closed = false;
      modals.forEach(function (m) {
        if (!m.hidden) {
          m.hidden = true;
          closed = true;
        }
      });
      if (closed) document.documentElement.style.overflow = '';
    });
  }

  function init() {
    setupPersonalizedProductValidation();
    setupInlineHeaderSearch();
    setupStickyCountdownBar();
    setupModelYearWarningPopup();
    setupSimHizmetiUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();